import http from './services/httpService';

export function createConversation(conversationData) {
    return http.post('/conversation', conversationData);
}